var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EncyclopediaHeader',{attrs:{"image":_vm.image,"name":_vm.name,"data-table":_vm.dataTable}})}
var staticRenderFns = []

export { render, staticRenderFns }